import React, { useEffect, useState, useRef } from 'react';
import { Line } from 'react-chartjs-2';
import { Chart, CategoryScale, LinearScale, LineElement, PointElement, Title, Tooltip, Legend } from 'chart.js';
import html2canvas from 'html2canvas';
import '../styles/ChartStyles.css';

Chart.register(CategoryScale, LinearScale, LineElement, PointElement, Title, Tooltip, Legend);

function PostagemPorPeriodoDia() { 
  const [chartData, setChartData] = useState(null);
  const chartRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/data`);
        const data = await response.json();

        if (!data || !Array.isArray(data) || data.length === 0) {
          console.error('Nenhum dado válido foi retornado da API');
          return;
        }

        const periodsOfDay = ["Matutino", "Vespertino", "Noturno", "Madrugada"];
        const counts = periodsOfDay.map(period => data.filter(item => item._source && item._source.periodo_dia === period).length);

        setChartData({
          labels: periodsOfDay,
          datasets: [
            {
              label: 'Número de Postagens por Período do Dia',
              data: counts,
              backgroundColor: 'rgba(75, 192, 192, 0.6)',
              borderColor: 'rgba(75, 192, 192, 1)',
              borderWidth: 2,
              fill: false,
            }
          ]
        });
      } catch (error) {
        console.error('Erro ao buscar dados:', error);
      }
    };

    fetchData();
  }, []);

  const exportChart = () => {
    if (chartRef.current && chartRef.current.canvas) {
      html2canvas(chartRef.current.canvas).then((canvas) => {
        const link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = 'Distribuição das Postagens por Período do Dia.png';
        link.click();
      });
    } else {
      console.error('Canvas do gráfico não está disponível');
    }
  };

  const exportData = () => {
    if (chartData) {
      const csvData = chartData.labels.map((label, index) => {
        return `${label},${chartData.datasets[0].data[index]}`;
      }).join('\n');
    
      const blob = new Blob([`Período do Dia,Número de Postagens\n${csvData}`], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'Distribuição das Postagens por Período do Dia.csv';
      link.click();
    } else {
      console.error('Dados do gráfico não estão disponíveis');
    }
  };

  return (
    <div className="chart-wrapper">
      <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>  
        {chartData ? <Line ref={chartRef} data={chartData} options={{
          plugins: {
            title: {
              display: true,
              text: 'Distribuição das Postagens por Período do Dia',
              font: {
                size: 18
              }
            },
            legend: {
              display: true,
              position: 'top'
            }
          }
        }} /> : <p>Carregando dados...</p>}
      </div>
      <div className="button-container">
        <button className="export-button" onClick={exportData}>Exportar Dados</button>
        <button className="export-button" onClick={exportChart}>Exportar Gráfico</button>
      </div>
    </div>
  );
}

export default PostagemPorPeriodoDia;
